import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_ens/layout";
import * as auth from "../_redux/authRedux";

class Logout extends Component {
  componentDidMount() {
    // Set logout flag before clearing sessionStorage
    sessionStorage.setItem('just_logged_out', 'true');

    // Clear all authentication data
    localStorage.removeItem('kt_token');
    localStorage.removeItem('persist:ens-auth');
    localStorage.removeItem('stai2SessionToken'); // Clear STAI2 session if exists

    // Call logout action
    this.props.logout();

    // Force redirect after a short delay to ensure state is cleared
    setTimeout(() => {
      if (this.props.hasAuthToken) {
        window.location.href = '/auth/login';
      }
    }, 100);
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
